export default __webpack_public_path__ + "static/media/call-to-action2.620aeeda.jpg";